// extracted by mini-css-extract-plugin
module.exports = {"main":"CardLayout_main__V029j","title":"CardLayout_title__Yl371"};